import * as yup from 'yup';
import { beneficiaryValidation } from '../../fields/Beneficiary/Beneficiary.meta';

export const validation = yup.object().shape({
  retirementAccountBeneficiaryInfo: beneficiaryValidation,
});
